import buttonActionThemes from "@streeteasy/design-system/button-action/buttonActionThemes";

export default {
  DANGER_PRIMARY: "DANGER_PRIMARY",
  DANGER_SECONDARY: "DANGER_SECONDARY",
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  DARK_BG: buttonActionThemes.DARK_PRIMARY,
  TERTIARY: buttonActionThemes.TERTIARY
};
